import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { jsonGet } from '../api';
import { File } from '../models/files';

type SliceModel = File;
const sliceName: string = 'files';

const currRequests: Set<ModelId> = new Set;

export const fetchFile = createAsyncThunk(
    sliceName + '/fetchById',
    async (id: ModelId) => {
        if (currRequests.has(id)) {
            return null;
        } else {
            currRequests.add(id);
            return await jsonGet<SliceModel>('/data/' + sliceName + '/' + id);
        }
    }
);

export const fileAdapter = createEntityAdapter<SliceModel>({
    selectId: (attrs: SliceModel) => attrs.id
});
export const fileSlice = createSlice({
    name: sliceName,
    initialState: fileAdapter.getInitialState(),
    reducers: {
        addMany: fileAdapter.addMany,
        addOne: fileAdapter.addOne,
        updateMany: fileAdapter.updateMany,
        updateOne: fileAdapter.updateOne,
        upsertOne: fileAdapter.upsertOne,
        upsertMany: fileAdapter.upsertMany,
        removeOne: fileAdapter.removeOne
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(fetchFile.fulfilled, (state, action) => {
            if (action.payload) {
                currRequests.delete(action.payload.id);
                fileAdapter.upsertOne(state, action.payload);
            }
        });
    },
});
